import { ConfirmPaymentModule } from './modules/confirm-payment-module';
import { ErrorPaymentModule } from './modules/error-payment-module';
import { SuccessPayment } from './modules/success-payment';
import {
  SuccessPaymentLayout,
  SuccessPaymentModule,
} from './modules/success-payment-module';

export {
  ConfirmPaymentModule,
  ErrorPaymentModule,
  SuccessPayment,
  SuccessPaymentLayout,
  SuccessPaymentModule,
};
